import { PricingSheetRow } from '../../../shared/types';

import { postPricingSheetItems } from '../services/pricingSheetItems';

export const formatPricingSheetItemsPost = (
  pricingSheetId: string,
  pricingSheetRows: any,
) => {
  return pricingSheetRows.map((pricingSheetRow: PricingSheetRow) => ({
    pricingSheetId: pricingSheetId,
    pricingItemId: `${pricingSheetId}-${pricingSheetRow.id}`,
    dayPrice: pricingSheetRow.dayPrice
      ? Math.round(pricingSheetRow.dayPrice)
      : undefined,
    proposalDayPrice: pricingSheetRow.proposalDayPrice
      ? Math.round(pricingSheetRow.proposalDayPrice)
      : undefined,

    monthPrice: pricingSheetRow.monthPrice
      ? Math.round(pricingSheetRow.monthPrice)
      : undefined,
    proposalMonthPrice: pricingSheetRow.proposalMonthPrice
      ? Math.round(pricingSheetRow.proposalMonthPrice)
      : undefined,

    itemId: pricingSheetRow.id,
    showByOfferText: pricingSheetRow.showByOfferText,
    rentalDaysDay: pricingSheetRow.rentalDaysDay,
    rentalDaysMonth: pricingSheetRow.rentalDaysMonth,
    estimatedYieldDay: Number(pricingSheetRow.estimatedYieldDay),
    estimatedYieldMonth: Number(pricingSheetRow.estimatedYieldMonth),
    historicYieldDay: Number(pricingSheetRow.rentalProfitDay),
    historicYieldMonth: Number(pricingSheetRow.rentalProfitMonth),
  }));
};

const postSheetRows = async (
  pricingSheetId: string,
  pricingSheetRows: any,
) => {
  const response = await postPricingSheetItems(
    formatPricingSheetItemsPost(pricingSheetId, pricingSheetRows),
  );
  return response;
};

export default postSheetRows;
